// 受注試算の燃費（車格別）— 純ロジック＋設定ストア（Supabase・DOM非依存）。
// 2026-08-28 オーナー決定（中型4km/L・大型2km/L）。正本: secretary-ナギ/notes/2026-08-28-decisions.md
// テスト: test_quote_fuel_class.mjs
//
// ⚠️ **二系統にしない**ための役割の境界（ここが唯一の説明箇所）:
//  - このファイルが持つのは **試算の燃費**。受注試算（配車・受注モーダル）の燃料費だけに効く。
//    燃料費 ＝ 距離 ÷ 車格別燃費 × 軽油単価。中型と大型で実際に倍近く違うため車格で分ける。
//  - **実績の燃費**（settings/assumptions.kmL）は別物。デジタコ実測の km/L を上書きする値で、
//    全社KPI・運行実績×収支・乗務員別の燃料計算にだけ効く（デジタコ未取込月の推定用）。
//    実績はデジタコ実測が正＝ここの値は**実績側に一切流さない**（operations.js はこのファイルを import しない）。
//  - 同じ「燃費」でも、片方は*これから出す見積の前提*、もう片方は*起きた実績の推定*。統合すると
//    実績の計算が試算の前提で動いてしまうため、フィールドを分けたまま UI ラベルで役割を書き分ける。
//  - 軽油単価（dieselYen）は実績側と**同じ値を共有**する（同じ物理量。二重に持たない）。
import { DIESEL_YEN_PER_L } from './analytics/operations.js'

export const QUOTE_FUEL_DEFAULTS = {
  medium: 4,                    // 中型 燃費 km/L（オーナー指定）
  large: 2,                     // 大型 燃費 km/L（オーナー指定・従来の一律値と同じ）
  dieselYen: DIESEL_YEN_PER_L,  // 軽油単価 円/L（実績側と同一ソース＝150）
}

const posNum = (v, def) => { const n = Number(v); return (v != null && v !== '' && isFinite(n) && n > 0) ? n : def }

// settings/assumptions の燃費フィールド → 正規化。未設定・不正値（非数・0・負・Infinity）は既定へ倒す
// （settings/display・settings/labor の先例踏襲）。0 を弾くのは 0除算＝∞円/km を作らないため。
export function normQuoteFuel(doc) {
  const d = doc || {}
  return {
    medium: posNum(d.quoteKmLMedium, QUOTE_FUEL_DEFAULTS.medium),
    large: posNum(d.quoteKmLLarge, QUOTE_FUEL_DEFAULTS.large),
    dieselYen: posNum(d.dieselYen, QUOTE_FUEL_DEFAULTS.dieselYen),
  }
}

// 設定ストア。main.js が起動時に、ダッシュボードの前提パネルが保存時に流し込む
// （operations.js の setLabor/getLabor と同じ流儀）。
let FUEL_CFG = normQuoteFuel(null)
export function setQuoteFuel(doc) { FUEL_CFG = normQuoteFuel(doc) }
export function getQuoteFuel() { return { ...FUEL_CFG } }

// cls: 'large'|'medium'（quoteOwnTrip の既存 vClass 判定を渡す）→ 燃費・単価・円/km。
export function fuelRateOf(cls, cfg) {
  const c = cfg ? normQuoteFuel(cfg) : getQuoteFuel()
  const kmPerL = cls === 'large' ? c.large : c.medium
  const yenPerL = c.dieselYen
  return { kmPerL, yenPerL, yenPerKm: Math.round(yenPerL / kmPerL * 100) / 100 }
}
